import { useQuery } from "@tanstack/react-query";
import { getContent } from "../api/content.api";
import { ContentRow } from "../api/content.type";

function useLoadContent() {
  const {
    data: content,
    isLoading,
    error,
  } = useQuery<ContentRow[]>({
    queryKey: ["content-list"],
    queryFn: () => getContent(),
  });

  return { content, isLoading, error };
}

export default useLoadContent;

